

export class ViajeReciboConforme {

public  idCompania: string;
public  idUsuario: string;
public  idViaje: string;
public  fecha: Date;
public  firma: string;
public  latitud: string;
public  longitud: string;

}